import React from "react";
import { LoginLayout } from "../components";
import { ResetPasswordForm } from "../features/auth";

const ForgotPasswordPage = () => (
  <LoginLayout>
    <ResetPasswordForm />
  </LoginLayout>
);

export default ForgotPasswordPage;
